<template>
  <div class="sisdai-leer-mas-menos">
    <div class="texto-corto"><slot name="texto-corto" /></div>
    <div class="texto-largo" v-bind:class="{'abierto': abierto || vistaSimplificada}">
      <slot name="texto-largo" />
    </div>
    <button class="btn-leer-mas-menos" v-if="!vistaSimplificada" @click="abierto=!abierto">
      {{abierto? "Leer menos": "Leer más"}}
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      abierto: false,
    }
  },
  computed: {
    vistaSimplificada() {
      return this.$store.getters.tieneVistaSimplificada;
    },
  },
}
</script>

<style scoped lang="scss">
.sisdai-leer-mas-menos {
  .texto-corto {
    * {
      margin-bottom: 0;
    }
  }
  .texto-largo {
    max-height: 0;
    overflow: hidden;
    transition: all .33s ease-in-out;
    &.abierto {
      max-height: 1660px;
    }
  }
  .btn-leer-mas-menos {
    margin-top: 16px;
  }
}
</style>
